/**
 * Copyright(c) 2019 Knut Petter Meen, all rights reserved.
 */
package net.scalytica.blaargh.models

import net.scalytica.blaargh.pages.Views.ArticleRef
import net.scalytica.blaargh.utils.StaticConfig.urlFromRoot
import org.scalajs.dom.ext.Ajax
import io.circe._
import io.circe.parser._
import japgolly.scalajs.react.Callback

import scala.concurrent.Future
import scala.concurrent.ExecutionContext.Implicits.global

import scala.scalajs.js

case class Article(
    date: String,
    author: String,
    title: String,
    ingress: String,
    labels: Seq[String],
    filename: String,
    image: String
) {

  def asJsDate: js.Date = new js.Date(date)

  def articleRef: ArticleRef = ArticleRef(shortDate, filename)

  def shortDate: String = date.take(10) // scalastyle:ignore

}

object Article {

  lazy val Articles: Future[Seq[Article]] = fetchAll


  val GalleryLabel        = "galleri"
  val PublicationsLabel   = "utgivelser"
  val FairyCreaturesLabel = "fabeldyr"

  def get(a: ArticleRef) =
    Ajax.get(url = a.htmlFilePath).map { xhr =>
      xhr.status match {
        case ok: Int if ok == 200 => Some(xhr.responseText)
        case _                    => None
      }
    }

  def fetchAll: Future[Seq[Article]] =
    Ajax
      .get(
        url = urlFromRoot("posts/posts.json"),
        headers = Map(
          "Accept"       -> "application/json",
          "Content-Type" -> "application/json"
        )
      )
      .map { xhr =>
        xhr.status match {
          case ok: Int if ok == 200 =>
            parse(xhr.responseText) match {
              case Left(ParsingFailure(message, err)) =>
                // scalastyle:off
                Callback.warn("Failed to load articles:\n" + message)
                Callback.warn("Error is:\n" + err.getMessage)
                // scalastyle:on
                Seq.empty[Article]

              case Right(json) =>
                json.as[Seq[Article]] match {
                  case Left(err) => throw err
                  case Right(art) => art.sortBy(_.date).reverse
                }
            }

          case _ =>
            Seq.empty[Article]
        }
      }.recover {
        case e: Throwable =>
          Callback.throwException(e)
          Seq.empty[Article]
      }

}



// WEBPACK FOOTER //
// /Users/kpm/Development/scalytica/renslebraten.no/_project/src/main/scala/net/scalytica/blaargh/models/Article.scala